import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2180. 発注ダッシュボード（案件別ランキング）
 * [GET] /workspaces/:identifier/purchase_dashboard/amount_by_order
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  payment_context_ids?: number[];
};

export type PurchaseDashboardAmountByOrder = {
  total_amount: number;
  order_rankings: { name: string; total_amount: number }[];
};

const purchaseDashboardAmountByOrder = (props: Props): Promise<PurchaseDashboardAmountByOrder> => {
  return axios.get(`/api/workspaces/${props.identifier}/purchase_dashboard/amount_by_order`, { params: props });
};

export const usePurchaseDashboardAmountByOrder = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'purchase_dashboard', 'amount_by_order', { ...props }],
    queryFn: () => purchaseDashboardAmountByOrder(props),
    staleTime: 1000 * 60 * 30,
  });
};
